export enum AuthAPIRoutes {
    LOGIN = "auth:authentication:login",
    REGISTER = "auth:users:register",
    RECOVER = "auth:users:password:recover",
    NEW_PASSWORD = "auth:users:password:change",
    CHANGE_USER_STATUS = "auth:users:status:change",
    GET_USERS = "auth:users:query",
    GET_USERS_PRIVILEGES = "auth:authorization:query",
    CREATE_USER = "auth:users:register",
    EDIT_USER = "auth:users:edit",
    GET_ROLES = "auth:authorization:query",
    CREATE_ROLE = "auth:authorization:role",
    DELETE_ROLE = "auth:authorization:role:delete",
    EDIT_ROLE = "auth:authorization:role:update",
    GET_RESOURCE_ENTITY = "auth:authorization:resourceentity:query",
    ADD_USER_TO_ROLE = "auth:permissions:assign",
    DELETE_USER_IN_ROLE = "auth:permissions:retract",
    GET_SUBSIDIARIES = "subsidiary:query"
}
